import { ScenarioBuilderView } from './ScenarioBuilderView';

export function ScenariosView() {
  return <ScenarioBuilderView />;
}
